<script>
export default {
  name: 'index',
  data() {
    return {
      deadline: Date.now() - new Date("2023-05-06"),
      stock: 0,
      admin: 0,
      user: 0,
      img: "",
      username: localStorage.getItem('name'),
      title: localStorage.getItem('title'),
      totalTime: 30,
      dTime: 0,
      setVisible: false,
      fileDataList: [],
      dialogImageUrl: '',
      lookImgVisible: false,
      disabled: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$axios.get("/admin/index").then((res) => {

        this.stock = res.data.data.stock
        this.admin = res.data.data.admin
        this.user = res.data.data.user
        const img = res.data.data.img
        const imgs = img.split("|");
        for (let i = 0; i < imgs.length; i++) {
          imgs[i] = '/image/' + imgs[i]
        }
        this.img = imgs
      })
    },
    // 编辑
    redact(e) {
      this.setVisible = true
      for (const i of this.img) {
        this.fileDataList.push({url:  i})
      }
    },
    // 图片处理
    handleRemove(file) {
      let removeId = file.uid
      this.fileDataList.forEach((item, index) => {
        if (item.uid == removeId) {
          this.fileDataList.splice(index, 1)
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.lookImgVisible = true;
    },
    handleDownload(file) {
      let a = document.createElement('a')
      a.href = file.url
      a.download = file.name
      a.click()
    },
    error() {
      this.$message.error("上传失败")
      this.$alert('请上传图片类型文件，或图片过大，图片最大为1MB，请使用画图工具将图片尺寸调小至1000像素以内', '上传失败', {
        confirmButtonText: '确定',
      });
    },
    success(response, file, fileList) {
      // this.fileDataList.push({url: '/image/' + file.response})
      this.fileDataList = fileList
      this.$message.success("上传成功")
    },
    exceed() {
      this.$message.warning("最多只可上传12张图片")
    },
    // 关闭对话框
    close() {
      this.fileDataList = []
      this.setVisible = false
    },
    // 设置图片
    setImg() {
      let img = ''
      for (const f of this.fileDataList) {
        if (f.name != null) {
          img += f.response + '|'
        } else {
          const arr = f.url.split("/")
          img += arr[arr.length - 2] + '/'
          img += arr[arr.length - 1] + '|'
        }
      }
      this.$axios.post("/admin/classImg", {
        id: 0,
        img: img.substring(0, img.length - 1),
      }).then((r) => {
        this.setVisible = false
        this.fileDataList = []
        this.$message.success("设置成功")
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "首页顶部图片",
          "name": this.username,
          "content": "设置了首页顶部图片"
        })
        this.getData()
      }).catch((e) => {
        this.$message.error("设置失败")
      })
    },
    closeImg() {
      this.dialogImageUrl = ''
      this.lookImgVisible = false
    },
    out() {
      this.$router.push({name: 'login'})
    },
    bf() {
      var that = this
      this.$prompt('请输入密码以验证身份', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
          var params = {token: localStorage.getItem('token'), password: value}
          fetch("/bf/download", {
              body: JSON.stringify(params),
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          ).then(res => {
            let n = that.$notify({
              title: '正在备份系统数据',
              duration: 0
            });
            let clock1 = window.setInterval(() => {
              that.dTime++
            }, 1000)
            res.blob().then(blob => {
              // 转化为blobURL后再通过a标签下载
              const blobUrl = window.URL.createObjectURL(blob);
              const a = window.document.createElement('a');
              a.href = blobUrl;
              let now = new Date();
              const m = now.getMonth() + 1
              a.download = now.getFullYear() + "-" + m + "-" + now.getDate() + ".zip";
              a.click();
              window.URL.revokeObjectURL(blobUrl);
              if (that.dTime < 3) {
                that.$alert('密码错误或没有管理员权限', '取消下载', {
                  type: 'error',
                  confirmButtonText: '确定',
                });
              } else {
                that.$alert('已完成下载，本次下载用时' + that.dTime + "秒", '下载完成', {
                  type: 'success',
                  confirmButtonText: '确定',
                });
              }
              n.close()
              that.dTime = 0
              window.clearInterval(clock1)
            });
          }).catch(() => {
          })
        }
      )
      ;
    }
  }
}
</script>
<template>
  <div class="main">
    <el-header>
      <div class="top">{{ title }}小程序管理系统</div>
      <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
        <div style="display:flex;align-items:center;">
          <el-avatar size="large" style="margin: 5px;"
                     src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
          {{ username }}
          <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
        </div>
      </div>
    </el-header>
    <el-main style="	display: flex;	flex-wrap: wrap;	align-items: stretch;">
      <div class="data">
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <el-statistic
                group-separator=","
                :value="stock"
                title="商品数"
              ></el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic title="用户数" :value="user">
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic
                group-separator=","
                :value="admin"
                title="管理员数量"
              >
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-carousel class="swiper" :interval="5000" arrow="always" height="384px">
        <el-carousel-item v-for="item in img" :key="item">
          <img width="100%" :src="item" alt="" style="object-fit:cover;">
        </el-carousel-item>
      </el-carousel>
      <div class="in_right">
        <el-button style="" type="primary" @click="redact">首页轮播图设置
        </el-button>
        <el-button style="" type="primary" @click="bf">备份系统数据
        </el-button>
      </div>
    </el-main>
    <el-dialog title="编辑图片" :visible.sync="setVisible" @close="close">
      <el-upload
        class="el-upload"
        :on-error="error"
        :limit="12"
        :on-exceed="exceed"
        :on-success="success"
        action="/admin/img"
        list-type="picture-card"
        :multiple="true"
        :file-list="fileDataList"
      >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img
            alt=""
            class="el-upload-list__item-thumbnail"
            :src="file.url"
          >
          <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="setImg()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="lookImgVisible" @close="closeImg">
      <img width="100%" :src="dialogImageUrl" alt="" append-to-body>
    </el-dialog>
  </div>
</template>
<style scoped>
.top {
  width: 400px;
  font-size: 40px;
  margin: 0 auto 50px;
}

.data {
  width: 100%;
  margin-top: 30px;
}

.main {
  width: 100%;
}

.in_right {
  margin-top: 100px;
  margin-left: 50px;
}

.swiper {
  margin-top: 100px;
  height: 384px;
  width: 750.4px;
}
</style>



// WEBPACK FOOTER //
// src/views/indexView.vue